import { io } from "socket.io-client";
import { isLive, isStaging } from "./setting";
// "undefined" means the URL will be computed from the `window.location` object
// const URL = "http://192.168.0.106:4000";

const localApiUrl = isLive
  ? isStaging
    ? "https://uatchat.scrapc.com/"
    : "https://chat.scrapc.com/"
  // : "http://192.168.0.125:3300"; // Ruchit
  : "http://localhost:3300";
export const chatImageUpload = `${localApiUrl}/chat/upload-image`;
const socket = io(localApiUrl, {
  transports: ["websocket", "polling"],
  autoConnect: false,
});

export default socket;
